module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteCopyCard.title":"Delete Copy","deleteCopyCard.subtitle":"Warning: This process is irreversible! The copy cloud connection data will be deleted permanently and you will need to re-copy your account if you want to see your data again.","dialogCloudAccount.copyCloudAccount":"Share Cloud Connection"}}')
  delete Component.options._Ctor
}
